import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enGBTranslation from './locales/en-GB.json';
import fiTranslation from './locales/fi.json';
import { Language, DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from './languages';

console.log('Initializing i18n...'); // Debug log for initialization

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      resources: {
        [Language.ENGLISH_GB]: {
          translation: enGBTranslation,
        },
        [Language.FINNISH]: {
          translation: fiTranslation,
        },
      },
      lng: DEFAULT_LANGUAGE,
      fallbackLng: FALLBACK_LANGUAGE,
      interpolation: {
        escapeValue: false,
      },
    },
    (err) => {
      if (err) {
        console.error('i18n initialization error:', err); // Log any initialization errors
      } else {
        console.log('i18n initialized successfully'); // Log successful initialization
        console.log('Loaded resources:', i18n.services.resourceStore.data); // Log loaded resources
      }
    }
  );

export default i18n;
